module.exports = __webpack_public_path__ + "static/media/5_2_A.d69a4835.png";